import { render, staticRenderFns } from "./KitchenEquipments.vue?vue&type=template&id=175b43be&"
import script from "./KitchenEquipments.vue?vue&type=script&lang=js&"
export * from "./KitchenEquipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports